import React from 'react';

const ListItemsContext = React.createContext({});

export const ListItemsProvider = ListItemsContext.Provider;

export default ListItemsContext;
